export default __webpack_public_path__ + "static/media/1657.a141c395.png";